export default __webpack_public_path__ + "static/media/ddsu5168-1.f2f8373c.png";